import React from "react";

// * Components
import Book from "../../components/Book-Section/Book";
import PageInfo from "../../components/Products-Info-Section/PageInfo";

// * Datas
import { Stories } from "../../Data/ProductData";
import { homeObjOne } from "./Data";

function Story() {
  return (
    <>
      <PageInfo {...homeObjOne} />
      <Book items={Stories} />
    </>
  );
}

export default Story;
